import React from 'react';
import Helmet from 'react-helmet';

/* Sad times. Helmet doesn't allow Fragment children, hence the ugly code you will see below. :( */

const SEOHelmet = ({ seo, origin, language, region, children }) => {
  if (!seo) {
    return <Helmet>{children}</Helmet>;
  }
  return (
    <Helmet titleTemplate={seo.titlePattern || null}>
      <html
        lang={seo.language}
        itemScope
        itemType="http://schema.org/Article"
      />
      {language && region && (
        <meta httpEquiv="content-language" content={`${language}-${region}`} />
      )}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@formlabs" />
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Formlabs" />
      {seo.title && <title>{seo.title}</title>}
      {seo.title && <meta name="twitter:title" content={seo.title} />}
      {seo.title && <meta property="og:title" content={seo.title} />}
      {seo.title && <meta itemProp="name" content={seo.title} />}
      {seo.description && <meta name="description" content={seo.description} />}
      {seo.description && (
        <meta itemProp="description" content={seo.description} />
      )}
      {(seo.description || seo.twitterDescription) && (
        <meta
          name="twitter:description"
          content={seo.twitterDescription || seo.description}
        />
      )}
      {(seo.description || seo.ogDescription) && (
        <meta
          property="og:description"
          content={seo.ogDescription || seo.description}
        />
      )}
      {seo.keywords && <meta name="keywords" content={seo.keywords} />}
      {seo.image && <meta itemProp="image" content={seo.image} />}
      {seo.image && <meta name="twitter:image:src" content={seo.image} />}
      {seo.image && <meta property="og:image" content={seo.image} />}
      {seo.noIndex && <meta name="robots" content="noindex" />}
      {seo.canonical && origin && (
        <link rel="canonical" href={origin + seo.canonical} />
      )}
      {seo.globalName &&
        (seo.globalName || seo.allHrefs).map(x => (
          <link
            key={x.locale}
            rel="alternate"
            href={x.path}
            hrefLang={x.locale}
          />
        ))}
      {children}
    </Helmet>
  );
};

export default SEOHelmet;
